import { createElement as f } from "react";
function o() {
  return o = Object.assign || function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, o.apply(this, arguments);
}
function m(r, e) {
  if (r == null) return {};
  var t = {}, n = Object.keys(r), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(e.indexOf(i) >= 0) && (t[i] = r[i]);
  return t;
}
var y = ["cdnSuffix", "cdnUrl", "countryCode", "style", "svg"], h = "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/", C = "svg", x = 127397, j = function(e) {
  var t = e.cdnSuffix, n = t === void 0 ? C : t, i = e.cdnUrl, a = i === void 0 ? h : i, l = e.countryCode, s = e.style, c = e.svg, u = c === void 0 ? !1 : c, d = m(e, y);
  if (typeof l != "string")
    return null;
  if (u) {
    var g = "" + a + l.toLowerCase() + "." + n;
    return f("img", Object.assign({}, d, {
      src: g,
      style: o({
        display: "inline-block",
        width: "1em",
        height: "1em",
        verticalAlign: "middle"
      }, s)
    }));
  }
  var v = l.toUpperCase().replace(/./g, function(p) {
    return String.fromCodePoint(p.charCodeAt(0) + x);
  });
  return f("span", Object.assign({
    role: "img"
  }, d, {
    style: o({
      display: "inline-block",
      fontSize: "1em",
      lineHeight: "1em",
      verticalAlign: "middle"
    }, s)
  }), v);
};
export {
  j as ReactCountryFlag,
  j as default
};
//# sourceMappingURL=react-country-flag.esm.es.js.map
